import * as _m0 from "protobufjs/minimal";
import { GetCaseRequest, GetCaseResponse } from "../getcase";
import { withAuthRetry } from '../utils/authRetry';
import { getServiceBaseUrl } from '../utils/api';

export async function getcase(request: GetCaseRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<GetCaseResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const encodedRequest = GetCaseRequest.encode(request).finish();

        const { baseUrl, stagingSuffix } = getServiceBaseUrl('intakeservice');
        const url = `${baseUrl}/getcase${stagingSuffix}?case_id=${request.caseId}`;

        const response = await fetch(
            url, {
            method: 'GET',
            headers,
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): GetCaseResponse => {
        return GetCaseResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}